class CSV {
    handle(file, fields, split, callback) {
        if (window.FileReader) {
            let lines = [];
            const readerInstance = new FileReader();

            readerInstance.onload = (function() {
                return function (event) {
                    const allowedTypes = ['text/csv', 'text/comma-separated-values', 'text/plain', ''];
                    /* If filetype is empty check file extension */
                    if (!allowedTypes.includes(file.type) && file.name.split('.').pop() !== 'csv') {
                        callback([], false);

                        return;
                    }

                    let csv = event.target.result;
                    let allTextLines = csv.split(/\r\n|\n/);
                    allTextLines.forEach(function(line) {
                        if (line) {
                            let target = {};

                            let lineItems = line.split(split);
                            lineItems.forEach(function(item, itemKey) {
                                target[fields[itemKey]] = item;
                            });

                            lines.push(target);
                        }
                    });

                    callback(lines, true);
                }
            })(file);

            readerInstance.onerror = (function(file) {
                if (event.target.error.name === "NotReadableError") {
                    alert("Cannot read file!");
                }

                callback([], false);
            });

            readerInstance.readAsText(file);
        }
    }
}

export default CSV;
